import React, { Component } from "react";
import { Card } from "@deere/ux.uxframe-react";
import deleteIconUrl from "@deere/ux.brand-foundations/icons/delete.svg";
import "../../commodities-services/components/scss/commodity.css";

class SubCommodityComponent extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      checked: true,
    };
    this.handleChecked = this.handleChecked.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleChecked(event) {
    this.setState({ isChecked: !this.state.isChecked });
    let valCheck = event.target.value;
    this.props.checkCards(valCheck);
  }

  handleDelete() {
    this.render();
    let itemcode = this.props.itemslist.code;
    this.props.deleteClick(itemcode);
  }

  render() {
    const { itemslist } = this.props;
    let count = 0;
    let checked = false;
    return (
      <span>
        <Card className="cardMargin">
          <span>
            <div class="card-body">
              <h5>{itemslist.title}</h5>
              <fieldset>
                {itemslist.itemList.map(itemObj => (
                  <div class="custom-control custom-checkbox" onChange={this.handleChecked}>
                    <input type="checkbox" class="" id={count++} value={itemObj.paramCode} checked={itemObj.selected} />
                    <label class="" for="customCheck3">{itemObj.paramValue}</label>
                  </div>
                ))}
                <div class="float-right">
                  <img src={deleteIconUrl} style={{ alignSelf: "center", height: 33, width: 33 }} />
                  <a className="text-decoration-none" href="#" onClick={this.handleDelete}>Delete Commodity</a>
                </div>
              </fieldset>
            </div>
          </span>
        </Card>
      </span>
    );
  }
}
export default SubCommodityComponent;
